import { BUY_PAGE } from '../../constants/pages';
import { LANDING_PAGE } from '../../constants/sessionStorage';
import {
  removeFromSessionStorage,
  retrieveFromSessionStorage,
} from './sessionStorageHelper';

// AuthRoute (render) and login pages (effects) can both call this in the same
// turn after JWT is set. Remember the value briefly so the second caller does
// not fall through to BUY_PAGE and wipe a deep-link redirect.
let consumedLandingPage = null;

export const landingPageHelper = (fallback = BUY_PAGE) => {
  const landingPage = retrieveFromSessionStorage(LANDING_PAGE);

  if (landingPage) {
    removeFromSessionStorage(LANDING_PAGE);
    consumedLandingPage = landingPage;
    setTimeout(() => {
      consumedLandingPage = null;
    }, 0);
    return landingPage;
  }

  if (consumedLandingPage) {
    const page = consumedLandingPage;
    consumedLandingPage = null;
    return page;
  }

  return fallback;
};

// Splits a stored landing path (may include ?query) into a location descriptor
// so callers can safely use history.push({ pathname, search, state }).
export const getLandingPageLocation = (fallback = BUY_PAGE) => {
  const landingPage = landingPageHelper(fallback);
  const questionIndex = landingPage.indexOf('?');

  if (questionIndex === -1) {
    return { pathname: landingPage };
  }

  return {
    pathname: landingPage.slice(0, questionIndex),
    search: landingPage.slice(questionIndex),
  };
};
